import { useEffect } from "react";

export const useGrammarCheck = () => {

  useEffect(() => {

    // Function to check grammar and spelling
    const getGrammarSuggestions = async (text) => {
      try {
        const response = await fetch("https://api.languagetool.org/v2/check", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ text, language: "en-US" })
        });
        const result = await response.json();
        return result.matches; // List of errors and suggestions
      } catch (err) {
        console.error("LanguageTool API error:", err);
        return [];
      }
    };

    // Show tooltip with suggestions
    const showTooltip = (input, matches) => {
      let existing = document.getElementById("grammar-tooltip");
      if (existing) existing.remove();
      if (matches.length === 0) return;

      const tooltip = document.createElement("div");
      tooltip.id = "grammar-tooltip";
      tooltip.style.position = "absolute";
      tooltip.style.background = "#fff8c6";
      tooltip.style.border = "1px solid #d1d1d1";
      tooltip.style.padding = "8px";
      tooltip.style.borderRadius = "4px";
      tooltip.style.zIndex = 9999;
      tooltip.style.maxWidth = "300px";
      tooltip.style.fontSize = "14px";

      tooltip.innerHTML = matches.map(m => 
        `<strong>${m.context.text.substring(m.context.offset, m.context.offset + m.context.length)}</strong>: ${m.message} <br> Suggested: ${m.replacements.map(r => r.value).join(", ")}`
      ).join("<hr>");

      document.body.appendChild(tooltip);

      const rect = input.getBoundingClientRect();
      tooltip.style.top = rect.bottom + window.scrollY + 5 + "px";
      tooltip.style.left = rect.left + window.scrollX + "px";
    };

    // Attach grammar check to a single input
    const attachGrammarCheck = (input) => {
      let timeout;
      input.addEventListener("input", () => {
        clearTimeout(timeout);
        timeout = setTimeout(async () => {
          const text = input.value;
          if (!text.trim()) return;
          const matches = await getGrammarSuggestions(text);
          showTooltip(input, matches);
        }, 500);
      });
      input.addEventListener("blur", () => {
        const existing = document.getElementById("grammar-tooltip");
        if (existing) existing.remove();
      });
    };

    // Attach to all inputs and textareas
    document.querySelectorAll("input[type=text], textarea").forEach(attachGrammarCheck);

    // Observe dynamically added inputs (React renders new components)
    const observer = new MutationObserver(mutations => {
      mutations.forEach(m => {
        m.addedNodes.forEach(node => {
          if (node.tagName === "INPUT" && node.type === "text") attachGrammarCheck(node);
          if (node.tagName === "TEXTAREA") attachGrammarCheck(node);
          if (node.querySelectorAll) {
            node.querySelectorAll("input[type=text], textarea").forEach(attachGrammarCheck);
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });

  }, []);
};